import {
  Button,
  Flex,
  Image,
  Stack,
  useColorMode,
  useColorModeValue,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  IconButton,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
// Custom Icons
import { ProfileIcon } from "components/Icons/Icons";
// Custom Components
import { SidebarResponsive } from "components/Sidebar/Sidebar";
import React, { useState, useRef } from "react";
import routesArray from "routes.js";
import { useUserActions } from "hooks/useUserActions";
import { authAtom } from "state/auth";
import { useRecoilValue } from "recoil";
import { getLogo } from "helpers/logo";

export default function HeaderLinks(props) {
  const routes = routesArray();
  const {
    variant,
    children,
    fixed,
    scrolled,
    secondary,
    onOpen,
    onOpenSearch,
    ...rest
  } = props;

  const { colorMode } = useColorMode();
  const userAction = useUserActions();
  const user = useRecoilValue(authAtom);
  const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false);
  const cancelRef = useRef();

  // Chakra Color Mode
  let navbarIcon =
    fixed && scrolled
      ? useColorModeValue("gray.700", "gray.200")
      : useColorModeValue("gray.700", "gray.200");
  if (secondary) {
    navbarIcon = "gray.700";
  }

  const handleLogoutClick = () => {
    setIsLogoutDialogOpen(true);
  };

  const handleConfirmLogout = () => {
    setIsLogoutDialogOpen(false);
    userAction.logout();
  };

  const handleCancelLogout = () => {
    setIsLogoutDialogOpen(false);
  };

  return (
    <>
      <Flex
        pe={{ sm: "0px", md: "16px" }}
        w={{ sm: "100%", md: "auto" }}
        alignItems="center"
        flexDirection="row"
        gap={{md: "10px", base: "6px"}}
      >
        <Button
          ms="0px"
          px="0px"
          color={navbarIcon}
          variant="no-effects"
          fontSize={{ base: "xs", md: "sm" }}
          rightIcon={
            document.documentElement.dir ? (
              ""
            ) : (
              <ProfileIcon color={navbarIcon} w={{ base: "18px", md: "22px" }} h={{ base: "18px", md: "22px" }} me="0px" />
            )
          }
          leftIcon={
            document.documentElement.dir ? (
              <ProfileIcon color={navbarIcon} w={{ base: "18px", md: "22px" }} h={{ base: "18px", md: "22px" }} me="0px" />
            ) : (
              ""
            )
          }
        >
          {user?.email ? user.email.split('@')[0] : ''}
        </Button>
        <SidebarResponsive
          logo={
            <Stack direction="row" spacing="12px" align="center" justify="center">
              <Image
                src={getLogo()}
                alt="logo"
                width={100}
                height={70}
                objectFit="contain"
              />
            </Stack>
          }
          colorMode={colorMode}
          secondary={props.secondary}
          routes={routes}
          {...rest}
        />
        <Button
          size="sm"
          onClick={handleLogoutClick}
          ml={{ base: "4px", md: "0" }}
        >
          Logout
        </Button>
      </Flex>

      <AlertDialog
        isOpen={isLogoutDialogOpen}
        leastDestructiveRef={cancelRef}
        onClose={handleCancelLogout}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent bg='white' borderRadius='12px' px={3} py={3} maxW='320px' w='90%' mx={4}>
            <IconButton
              aria-label='Close dialog'
              icon={<CloseIcon boxSize={2} />}
              position='absolute'
              top={2}
              right={2}
              onClick={handleCancelLogout}
              borderRadius='full'
              border='1px solid'
              borderColor='gray.200'
              bg='white'
              _hover={{ bg: 'gray.50' }}
              size='xs'
              minW='24px'
              h='24px'
            />

            <AlertDialogHeader fontSize='lg' fontWeight='700' color='#0DB34A' textAlign='left' pb={1} pt={1}>
              Logout
            </AlertDialogHeader>

            <AlertDialogBody py={2} color='gray.700' fontSize='sm' textAlign='left'>
              Are you sure you want to logout?
            </AlertDialogBody>

            <AlertDialogFooter pt={2} pb={1}>
              <Button
                ref={cancelRef}
                onClick={handleCancelLogout}
                bg='gray.100'
                _hover={{ bg: 'gray.200' }}
                color='gray.800'
                borderRadius='8px'
                px={3}
                size='sm'
                h='32px'
              >
                Cancel
              </Button>
              <Button
                bg='#053957'
                color='white'
                ml={2}
                onClick={handleConfirmLogout}
                _hover={{ bg: '#042e45' }}
                borderRadius='8px'
                px={3}
                size='sm'
                h='32px'
              >
                Logout
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
